
import CloudFun, { Condition, Operator } from '@cloudfun/core'
import { defineComponent, onMounted, ref } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
  setup() {
    const model = CloudFun.current?.model;
    const hasOrders = ref(false);
    const hasContacts = ref(false);
    const searchDropdown = ref(false)

    onMounted(() => {
      setInterval(async () => {
        let temp: any;
        temp = await model?.dispatch("order/query", { condition: new Condition("Status", Operator.Equal, (model.enums as any).OrderStatus.PaymentConfirmed.Value), page: 1, pageSize: 1 });
        hasOrders.value = !!temp.data?.[0];
        temp = await model?.dispatch("customerContact/query", { condition: new Condition("ReplyContent", Operator.IsNull), page: 1, pageSize: 1 })
        hasContacts.value = !!temp.data?.[0];
      }, 60000);
    });
    const showSearchDropdown = () => {
      searchDropdown.value = true
    }

    const hideSearchDropdown = () => {
      searchDropdown.value = false
    }

    return {
      hasOrders,
      hasContacts,
      searchDropdown,
      showSearchDropdown,
      hideSearchDropdown,
      isGuest: !CloudFun.current?.user.Id
    }
  },
  computed: {
    ...mapGetters(['user']),
    homePath() {
      const path = this.$route.path
      if (path.startsWith('/simple-menu')) return '/simple-menu'
      if (path.startsWith('/top-menu')) return '/top-menu'
      return '/'
    }
  },
  methods: {
    logout() {
      if (!this.$user.Id) {
        this.$router.push('/login')
        return
      }
      this.$model.dispatch('logout').finally(() => {
        this.$model.user = this.$model.guest
        this.$router.push('/login')
      })
    }
  },
  watch: {
    user(current) {
      this.isGuest = !current.Id
    }
  }
})
